/**
 * True only when an image is safe to hand to canvas drawImage.
 *
 * `complete` alone is not enough: an image that failed to load also reports
 * `complete === true`, but has no intrinsic size. Drawing one throws
 * "CanvasRenderingContext2D.drawImage: Passed-in image is broken", which is an
 * uncaught DOMException during render and takes the React tree down with it.
 *
 * Same check RawImageCache already makes before invoking its callback.
 *
 * @param {HTMLImageElement|null} image
 * @returns {boolean}
 */
const isDrawableImage = (image) =>
  !!(
    image &&
    image.src &&
    image.complete &&
    typeof image.naturalWidth !== 'undefined' &&
    image.naturalWidth !== 0
  );

export default isDrawableImage;
